import { useEffect } from 'react';
import { Flex, Layout } from 'antd';
import layoutStyles from 'components/Layout/Layout.module.scss';
import { useAppDispatch } from 'app/hooks';
import { logErrors } from 'utils';
import { PageTitle, PageDescription } from 'components/PagePartials';
import Header from 'components/CenterHeader/Header';
import Img from 'components/Img';
import { clearStore } from 'services/session/sessionAsync';
import offlineIcon from 'assets/common/offline-wifi.svg';
import styles from './index.module.scss';

function Offline() {
  const dispatch = useAppDispatch();

  /* clear the user session */
  useEffect(() => {
    async function clearUserSession() {
      try {
        await dispatch(clearStore());
      } catch (error) {
        logErrors(error);
      }
    }

    clearUserSession();
  }, []);

  return (
    <Layout className={`${layoutStyles.container} ${styles.layoutContainer}`}>
      <div className={layoutStyles.stickyContainer}>
        <Header />
      </div>
      <Flex vertical className={`${layoutStyles.contentWrapper} alignStretch`}>
        <Layout.Content
          className={`${layoutStyles.content} verticalFlex alignStretch`}
        >
          <Flex vertical className={layoutStyles.pageSectionWrapper}>
            <Flex
              vertical
              className='fullWidth fullHeight'
              align='center'
              justify='center'
            >
              <Flex
                vertical
                align='center'
                className={`${styles.offlineContainer} gap24`}
              >
                <div className={styles.iconWrapper}>
                  <Img
                    src={offlineIcon}
                    alt=''
                    width={64}
                    height={64}
                    className={styles.icon}
                  />
                </div>
                <div className='verticalCenter gap16'>
                  <PageTitle className={styles.title}>
                    You are offline!
                  </PageTitle>
                  <div className='verticalCenter gap8'>
                    <PageDescription section>
                      <strong>Error:</strong> Internet Connection Lost
                    </PageDescription>
                    <PageDescription section className='textCenter'>
                      It looks like your internet connection has been
                      interrupted. Please check your network connection.
                    </PageDescription>
                  </div>
                </div>
              </Flex>
            </Flex>
          </Flex>
        </Layout.Content>
      </Flex>
    </Layout>
  );
}

export default Offline;
